import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

const CallBackOnAppear = ({ callback, once, children }) => {
  const containerRef = useRef(null);
  const isVisible = useRef(false);

  useEffect(() => {
    function watchForAppear() {
      const { current: container } = containerRef;
      if (container) {
        const { height, y } = container.getBoundingClientRect();
        const isFullyShown = y + height <= window.innerHeight;
        if (isFullyShown && !isVisible.current) {
          isVisible.current = true;
          if (once) {
            window.removeEventListener('scroll', watchForAppear);
          }
          callback();
        } else if (!isFullyShown && isVisible.current) {
          isVisible.current = false;
        }
      }
    }

    window.addEventListener('scroll', watchForAppear);

    watchForAppear();

    return function cleanup() {
      window.removeEventListener('scroll', watchForAppear);
    };
  }, []);

  return <span ref={containerRef}>{children}</span>;
};

CallBackOnAppear.propTypes = {
  callback: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  once: PropTypes.bool,
};

CallBackOnAppear.defaultProps = {
  once: true,
};

export default CallBackOnAppear;
